import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import Slide from '@material-ui/core/Slide';
import { TransitionProps } from '@material-ui/core/transitions';

import SelectedTableCell from '../SelectedTableCell';
import CategorySelectTableCell from '../CategorySelectTableCell';
import PurchaseRow from '../../models/PurchaseRow';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export interface ChangeSelectedDialogProps {
  row?: PurchaseRow;
  open: boolean;
  onClose: (row?: PurchaseRow) => void;
}

const ChangeSelectedDialog: React.FC<ChangeSelectedDialogProps> = (props: ChangeSelectedDialogProps) => {
  const { row, open, onClose } = props;
  const [ currentRow, setCurrentRow ] = React.useState(row?.clone());

  if (row && currentRow?.cloneOf!==row.id) {
    setCurrentRow(row?.clone());
  }

  if (currentRow) {
    const getChanger = function<T extends keyof PurchaseRow>(fieldName: T) {
      return {
        get: () => currentRow[fieldName],
        set: (value: PurchaseRow[T]) => {
          currentRow[fieldName] = value as never;
          setCurrentRow(currentRow);
        }
      };
    };

    const handleClose = () => {
      onClose();
    };

    const handleChange = () => {
      onClose(currentRow);
    };

    return (
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        TransitionComponent={Transition}
        keepMounted
        TransitionProps={{onExited: ()=>{setCurrentRow(undefined);onClose();}}}
      >
        <DialogTitle id="form-dialog-title">Изменить выбранные строки</DialogTitle>
        <DialogContent>
          <Table size="small" aria-label="позиции для закупки">
            <TableBody>
              <SelectedTableCell label="Пол" options="undefined=не менять;=;м=м;ж=ж;у=у" value={getChanger('sex')} />
              <SelectedTableCell label="Возраст" options="undefined=не менять;=;1=взрослые;2=дети;3=новорожденные" value={getChanger('age')} />
              <SelectedTableCell label="Слой одежды" options="undefined=не менять;=;1=нижнее белье;2=2 слой;3=верхняя одежда;4=головные уборы" value={getChanger('weatherLayer')} />
              <CategorySelectTableCell label="Категория" value={getChanger('category')} />
            </TableBody>
          </Table>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Отмена
          </Button>
          <Button onClick={handleChange} color="primary">
            Изменить
          </Button>
        </DialogActions>
      </Dialog>
    );
  } else {
    return (
      <Dialog
        open={false}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title"></DialogTitle>
      </Dialog>
    );
  }
}

export default ChangeSelectedDialog;
